import { useLocation } from "react-router-dom";

/** 
 * 自網址取出QueryString 並轉換成Dictionary 
 * @param encode 是否需對網址decode, 通常用於跳轉網址
 * */
export function useQueryParam<T>(decode?: boolean) {
  const location = useLocation();

  const queryParam: T = Object.fromEntries(
    (decode ? decodeURIComponent(location.search) :
      location.search)
      .substring(1)
      .split("&")
      .map((keyAndValue) => keyAndValue.split("="))
  );

  return queryParam;
}
